import { defineAction } from '~/prix'
import { z } from 'zod'
import collectionIncentiveUpdateAction from './collectionIncentiveUpdate.action.json' with { type: 'json' }
import { collectionIncentiveObject } from '../collectionIncentiveObject'

const collectionIncentiveUpdateDefinition = defineAction({
  ...collectionIncentiveUpdateAction,

  input: collectionIncentiveObject.pick({ id: true, notes: true }).partial().required({ id: true }),
  output: z.object({}),
})

export default collectionIncentiveUpdateDefinition
